import Joi from "joi";

/** Must stay in sync with backend `visitType.schema.js` enum */
export const VISIT_TYPE_OPTIONS = ["OPD", "IPD", "Both"];

const VisitTypeSchema = Joi.object({
  name: Joi.string().trim().required().messages({
    "string.empty": "Name is required.",
  }),
  visitType: Joi.string()
    .trim()
    .valid(...VISIT_TYPE_OPTIONS)
    .required()
    .messages({
      "any.only": "Visit Type must be OPD, IPD, or Both.",
      "string.empty": "Visit Type is required.",
    }),
}).unknown(true);

export default VisitTypeSchema;
